import { render } from "./ViewTransactionModal.vue?vue&type=template&id=364ede99"
import script from "./ViewTransactionModal.vue?vue&type=script&lang=js"
export * from "./ViewTransactionModal.vue?vue&type=script&lang=js"

import "./ViewTransactionModal.vue?vue&type=style&index=0&id=364ede99&lang=css"
script.render = render

export default script